<template>
  <div class="key-container">
    <div class="keyboard" @click.stop="_handleKeyPress">
      <div class="key-row" data-num="-1">
        <div class="key-cell" id="key-7" data-num="7">7</div>
        <div class="key-cell" id="key-4" data-num="4">4</div>
        <div class="key-cell" id="key-1" data-num="1">1</div>
        <div class="key-cell" id="key-00" data-num="00">00</div>
      </div>
      <div class="key-row" data-num="-1">
        <div class="key-cell" id="key-8" data-num="8">8</div>
        <div class="key-cell" id="key-5" data-num="5">5</div>
        <div class="key-cell" id="key-2" data-num="2">2</div>
        <div class="key-cell" id="key-." data-num=".">.</div>
      </div>
      <div class="key-row" data-num="-1">
        <div class="key-cell" id="key-9" data-num="9">9</div>
        <div class="key-cell" id="key-6" data-num="6">6</div>
        <div class="key-cell" id="key-3" data-num="3">3</div>
        <div class="key-cell" id="key-0" data-num="0">0</div>
      </div>
      <div class="key-row" data-num="-1">
        <div class="key-cell" id="key-D" data-num="D" style="flex:1">删除</div>
        <div class="key-cell" id="key-C" data-num="C" style="flex:1">清除</div>
        <!-- <div class="key-cell" data-num="S" style="flex:2">确认</div> -->
      </div>
    </div>
  </div>
</template>

<script>
// 點擊事件
export default {
  props: ["money"],
  data() {
    return {
      preMoney: this.money
    };
  },
  watch: {
    money(val) {
      this.preMoney = val;
      console.log("money变化", this.money, "preMoney", this.preMoney);
      // this.$parent.inputPrice = val;
    },
    preMoney(val) {
      this.$emit("focusMethods", val);
    }
  },
  mounted() {
    console.log("preMoney", this.preMoney);
  },
  methods: {
    //处理按键
    _handleKeyPress(e) {
      let num = e.target.dataset.num;
      //不同按键处理逻辑
      // -1 代表无效按键，直接返回

      if (num == -1) return false;
      let idName = "key-" + num;
      document.getElementById(idName).className = "clicked key-cell";
      setTimeout(() => {
        document.getElementById(idName).className = "key-cell";
      }, 100);
      switch (String(num)) {
        //小数点
        case ".":
          this._handleDecimalPoint();
          break;
        //删除键
        case "D":
          this._handleDeleteKey();
          break;
        //清空键
        case "C":
          this._handleClearKey();
          break;
        //确认键
        case "S":
          this._handleConfirmKey();
          break;
        default:
          this._handleNumberKey(num);
          break;
      }
      // this.$parent.$refs.inputPrice.focus();
    },
    //处理小数点函数
    _handleDecimalPoint() {
      //如果包含小数点，直接返回
      if (this.preMoney.indexOf(".") > -1) return false;
      //如果小数点是第一位，补0
      if (!this.preMoney.length) this.preMoney = "0.";
      //如果不是，添加一个小数点
      else this.preMoney = this.preMoney + ".";
    },
    //处理删除键
    _handleDeleteKey() {
      let S = this.preMoney;
      //如果没有输入，直接返回
      if (!S.length) return false;
      //否则删除最后一个
      this.preMoney = S.substring(0, S.length - 1);
    },
    //处理清空键
    _handleClearKey() {
      this.preMoney = "";
    },
    //处理数字
    _handleNumberKey(num) {
      let S = this.preMoney;
      //如果有小数点且小数点位数不小于2
      if (S.indexOf(".") > -1 && S.substring(S.indexOf(".") + 1).length < 2)
        this.preMoney = S + num;
      //没有小数点
      if (!(S.indexOf(".") > -1)) {
        //如果第一位是0，只能输入小数点
        if (num == 0 && S.length == 0) this.preMoney = "0.";
        else {
          if (S.length && Number(S.charAt(0)) === 0) return;
          this.preMoney = S + num;
        }
      }
      if (S.length > 5) {
        this.preMoney = S.substring(0, 6);
      }
    },
    //提交
    _handleConfirmKey() {
      let S = this.preMoney;
      //未输入
      if (!S.length) {
        alert("您目前未输入!");
        return false;
      }
      //将 8. 这种转换成 8.00
      if (S.indexOf(".") > -1 && S.indexOf(".") == S.length - 1)
        S = Number(S.substring(0, S.length - 1)).toFixed(2);
      //保留两位
      S = Number(S).toFixed(2);
      // this.$emit("confirmEvent", S);
    }
  }
};
</script>

<style scoped>
.key-container {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.input-box {
  font-size: 35px;
  font-weight: bold;
  height: 40px;
  border-bottom: 1px solid #aaa;
  padding: 10px 15px;
  text-align: right;
  width: 90%;
}
.keyboard {
  position: relative;
  bottom: 0;
  left: 0;
  /* height: 340px; */
  width: 100%;
  display: flex;
}
.keyboard .key-row {
  flex: 1;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  position: relative;
}
.keyboard .key-row::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 1px;
  color: #d5d5d6;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.keyboard .key-cell {
  /* flex: 1; */
  font-size: 16px;
  /* -webkit-box-flex: 1; */
  text-align: center;
  position: relative;
  margin: 5px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background: #ffffff;
  cursor: pointer;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.keyboard .key-cell::after {
  content: "";
  position: absolute;
  overflow: hidden;
  top: 0;
  right: 0;
  bottom: 0;
  height: 200%;
  color: #d5d5d6;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.keyboard .key-cell:nth-last-child(1)::after {
  border-right: 0;
}
.clicked {
  transform: scale(0.9, 0.9);
  background: black;
  background-color: #ccc !important;
}

.keyboard .disabled {
  background: rgba(0, 0, 0, 0.2);
}
.keyboard .key-confirm {
  position: absolute;
  text-align: center;
  height: 118px;
  width: 23%;
  line-height: 118px;
  background: #fff;
  z-index: 5;
  right: 6px;
  bottom: 0;
}
</style>
